import React, { useState } from 'react';
import styled from 'styled-components';
import Projects from '../components/Projects';
import ProjectDetails from '../components/ProjectDetails';

const PageSection = styled.div`
  width: 100%;
`;

const ProjectsPage = () => {
  const [openModal, setOpenModal] = useState({ state: false, project: null });

  return (
    <PageSection>
      <Projects openModal={openModal} setOpenModal={setOpenModal} />
      {openModal.state && (
        <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
      )}
    </PageSection>
  );
};

export default ProjectsPage;

